<script setup>
import { useI18n } from "vue-i18n";
import { computed } from "vue";
import PopupComponent from "./components/AppComponents/PopupComponent/PopupComponent.vue"

const { t } = useI18n(); // call `useI18n`, and spread `t` from  `useI18n` returning
const id = computed(() => this.$store.getters.id);
const verified = computed(() => this.$store.getters.verified);
</script>

<template>
  <div class="container-fluid vh-100 p-0 app-view">
    <PopupComponent />
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<style>
.app-view {
  max-width: 720px !important;
}
</style>